import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import TranslationProvider from '../../providers/TranslationProvider';
import './PartnershipBranding.scss';

const PartnershipBranding = (props) => {
  const { alt, image } = props;

  return (
    <div
      className="PartnershipBranding"
      role="region"
    >
      <TranslationProvider translationKey="in_partnership_with">
        <span
          aria-label={`In Partnership With ${alt}`}
          className="PartnershipBranding__copy"
        >
          In Partnership With
        </span>
      </TranslationProvider>
      <Icon alt="" iconClass="PartnershipBranding__image" url={image} />
    </div>
  );
};

PartnershipBranding.propTypes = {
  alt: PropTypes.string,
  image: PropTypes.string.isRequired,
};

PartnershipBranding.defaultProps = {
  alt: 'Partner Logo',
};

PartnershipBranding.displayName = 'PartnershipBranding';
export default PartnershipBranding;
